<template>
	<div v-on="$listeners" class="surf-inline-two-text-style1 surf-transition-hover-lift">
		<div class="content">
			<div class="date">
				<div class="year">{{ formattedYear }}</div>
				<div class="other">{{ formattedOther }}</div>
			</div>
			<div class="value-section">
				<div class="value text-overflow">{{ formattedItem.value }}</div>
				<div class="sub-value">{{ formattedItem.value2 }}</div>
			</div>
		</div>
		<div class="icon">
			<SvgIcons v-if="isMobile" name="surf_frame_white" class="frame-icon" />
			<SvgIcons v-else name="surf_frame" class="frame-icon" />
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import dayjs from 'dayjs';
import { useStore } from '@/utils/vue-api';

const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	formatter: {
		type: Function,
		default: null
	}
});

const store = useStore();
const isMobile = computed(() => store.getters.isMobileMode);

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		return { ...props.item, ...formattedData };
	}
	return props.item;
});

const formattedYear = computed(() => {
	return dayjs(formattedItem.value.date).format('DD');
});
const formattedOther = computed(() => {
	return dayjs(formattedItem.value.date).format('YYYY.MM');
});
</script>

<style lang="less" scoped>
.surf-inline-two-text-style1 {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;
	padding: 19px 40px;
	border-radius: 8px;
	background-color: var(--surf-secondary-color);
	cursor: pointer;

	.content {
		flex: 1;
		width: 0;
		display: flex;
		align-items: center;
		gap: 80px;

		.date {
			text-align: center;
			position: relative;

			&::before {
				content: '';
				position: absolute;
				top: 11px;
				right: -40px;
				bottom: 11px;
				width: 1px;
				background: rgba(var(--surf-inverse-color-rgb), 0.15);
				transform: scaleX(0.5);
				transform-origin: center;
				pointer-events: none;
			}

			.year {
				color: rgba(var(--surf-inverse-color-rgb), 0.4);
				font-family: D-DIN;
				font-size: 40px;
				font-weight: 700;
				line-height: 48px;
			}
			.other {
				margin-top: 4px;
				color: rgba(var(--surf-inverse-color-rgb), 0.4);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
			}
		}

		.value-section {
			flex: 1;
			width: 0;
			display: flex;
			flex-direction: column;

			.value {
				color: var(--surf-inverse-color);
				font-size: 16px;
				font-weight: 400;
				line-height: 24px;
			}

			.sub-value {
				margin-top: 16px;
				color: rgba(var(--surf-inverse-color-rgb), 0.4);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
			}
		}
	}

	.icon {
		display: flex;
		align-items: center;
		justify-content: center;

		.frame-icon {
			font-size: 56px;
			color: var(--surf-inverse-color) !important;
		}
	}
}

.mob-surf-layout {
	.surf-inline-two-text-style1 {
		position: relative;
		padding: 16px 12px;
		overflow: hidden;

		.content {
			gap: 24px;

			.date {
				.year {
					font-size: 24px;
					line-height: 32px;
				}
				.other {
					margin-top: 4px;
					font-size: 10px;
					line-height: 14px;
				}
				&::before {
					right: -12px;
					top: 0;
					bottom: 0;
				}
			}
			.value {
				font-size: 15px;
				line-height: 20px;
			}
			.sub-value {
				margin-top: 10px;
				font-size: 12px;
				line-height: 16px;
			}
		}

		.icon {
			position: absolute;
			right: 0;
			bottom: 0;
			opacity: 0.1;

			.frame-icon {
				font-size: 32px;
			}
		}
	}
}
</style>
